/**
 * On Android, native screens scroll an inner container rather than the document — see
 * NativeLayout. That keeps Android's over-scroll stretch confined to the page content, so it no
 * longer smears the fixed bottom nav bar (which sits outside the scroller).
 *
 * The consequence is that `window.scrollTo` is a no-op there, so anything that needs to scroll the
 * page must go through here. iOS and web have no such container and scroll the document as before,
 * which is what the null return means — so this is a feature detect, not a platform check.
 */
export const NATIVE_SCROLL_CONTAINER_ID = "native-scroll"

export function getScrollContainer(): HTMLElement | null {
  return document.getElementById(NATIVE_SCROLL_CONTAINER_ID)
}

export function scrollToTop({ smooth = false }: { smooth?: boolean } = {}) {
  const behavior: ScrollBehavior = smooth ? "smooth" : "auto"

  const scroller = getScrollContainer() ?? window
  scroller.scrollTo({ top: 0, behavior })
}
